/**
 * Wipe-clean grip tape, approved for food service and, apparently, for this.
 */

import type { Affix } from '@/sim/items/affixContract';

export const SANITARY_GRIP = {
  id: 'sanitaryGrip',
  slot: 'prefix',
  field: 'handling',
  direction: -1,
  label: 'Faster to aim',
  nameWord: 'Sanitary',
  ranges: {
    common: { min: 0.05, max: 0.09 },
    uncommon: { min: 0.09, max: 0.15 },
    rare: { min: 0.15, max: 0.22 },
    exotic: { min: 0.22, max: 0.3 },
  },
} as const satisfies Affix;
